/*eslint-disable */
import { useMutation } from "@apollo/client";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { Box, Button, Card, Checkbox, Container, Grid, Table, TableBody, TableCell, TableHead, TableRow, styled, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GET_TITLE } from "../../gql/utils";
import MainLoader from "../MainLoader/MainLoader";
import CombineTableData from "./CombineTableData";
import GPTDataTable from "./GPTDataTable";
import GeminiDataTable from "./GeminiDataTable";
const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 70px)",
  display: "flex",
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
  padding: "0px 0 30px",
  "& .SomethingWrong": {
    color: theme.palette.text.primary,
  },
  "& .AccordionListWrapper": {
    "& .MuiAccordion-root": {
      boxShadow: "none",
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: "10px",
      marginBottom: "10px",
      "&::before": {
        display: "none",
      },
      "& .MuiAccordionSummary-root": {
        "& .MuiAccordionSummary-content": {
          "& p": { wordBreak: "break-all" },
        },
      },
      "& .MuiAccordionDetails-root": {
        "& .KeywordListWrapper": {
          "& .MainHeading": {
            fontSize: "18px",
            fontWeight: 600,
            marginBottom: "18px",
            "&.VerifiedKeywords": {
              marginTop: "22px",
            },
          },
          "& .NotFoundWrapper": {
            padding: "10px 0 10px",
            "& h5": {
              textAlign: "center",
              fontSize: "14px",
            },
          },
          "& .KeywordListInner": {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            flexWrap: "wrap",
            gap: "15px",
            maxHeight: "200px",
            overflowY: "auto",
            "@media screen and (max-width: 600px)": {
              flexDirection: "column",
              flexWrap: "nowrap",
              alignItems: "flex-start",
            },
            "&::-webkit-scrollbar-track": {
              borderRadius: "10px",
              backgroundColor: theme.palette.text.primary + "0d",
            },
            "&::-webkit-scrollbar": { width: "8px", backgroundColor: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              borderRadius: "10px",
              WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
              backgroundColor: theme.palette.primary.main,
            },
            "& span.Tags": {
              backgroundColor: theme.palette.primary.main + "1a",
              fontSize: "12px",
              padding: "3px 14px 3px",
              borderRadius: "12px",
              color: theme.palette.primary.main,
            },
          },
        },
      },
    },
  },
  "& .PaginationWrapper": {
    marginTop: "25px",
    "& nav": {
      "& ul": {
        justifyContent: "flex-end",
        "@media screen and (max-width: 600px)": {
          justifyContent: "center",
        },
        "& li": {
          "& button": {
            "&.Mui-selected": {
              backgroundColor: theme.palette.primary.main + "2b",
              color: theme.palette.primary.main,
            },
          },
          "@media screen and (max-width: 600px)": {
            "&:first-of-type, &:last-of-type": {
              display: "none",
            },
          },
        },
      },
    },
  },

  "& .KeywordsWrapper": {
    "& .FindInputWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "15px",
      "& .InputStyleWrapper": {
        flex: "1",
        "& .selectWrapper": {
          color: theme.palette.text.primary,
          "& .MuiOutlinedInput-root": {
            "&:hover": {
              border: "none !important",
              outline: "none",
            },
          },
          "&::placeholder": {
            color: theme.palette.text.primary,
          },
          "& input": {
            color: theme.palette.text.primary,
            "&:hover": {
              border: `none `,
              borderRadius: "5px",
            },
          },
        },
      },
      "& .GenerateBtn": {
        padding: "10px 20px 10px",
      },
    },
    "& .KeywordTableWrapper": {
      "& .TableMainHeading": {
        fontSize: "18px",
        fontWeight: 900,
        marginBottom: "20px",
        marginTop: "30px",
      },
      "& .TableMainWrapper": {
        boxShadow: "none",
        border: `1px solid ${theme.palette.divider}`,
        "& table": {
          "& thead": {
            "& tr": {
              "& th": {
                fontSize: "14px",
                fontWeight: 600,
                whiteSpace: "nowrap",
              },
            },
          },
          "& tbody": {
            "& tr": {
              "& td": {
                paddingTop: "15px",
                paddingBottom: "15px",
                fontSize: "12px",
                fontWeight: 600,
                "& .ViewReportBtn": {
                  whiteSpace: "nowrap",
                },
              },
            },
          },
        },
      },
    },
    "& .FooterBtnWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "15px",
      marginTop: "10px",
      "& button": {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
        "&.Mui-disabled": {
          opacity: 0.3,
          color: "#474747",
        },
      },
    },
  },
}));

const BoxWrapper = styled(Box)(({ theme }) => ({
  borderRadius: "7px",
  marginBottom: "20px",
  "& .TableMainHeading": {
    color: theme.palette.text.primary,
    fontWeight: 800,
    fontSize: "25px",
  },
  "& table.KewordTable": {
    marginTop: "25px",
  },
  "& table.KewordTable tbody tr td": {
    color: theme.palette.text.primary,
    fontSize: "15px",
    padding: "5px 16px !important",
  },
  "&  table.KewordTableTop tbody tr": {
    "&:last-child": {
      borderBottom: "1px solid #e5eaef",
    },
  },
  "& table.KewordTable tbody tr td label span": {
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  "& table.KewordTable thead tr th": {
    color: theme.palette.text.primary,
    fontWeight: 800,
    fontSize: "15px",
  },
  "& table.KewordTable .selectTitleTableHead tr th": {
    color: theme.palette.text.primary,
    fontWeight: 800,
    fontSize: "15px",
    padding: "5px 20px !important",
  },
  "& table .deleteIconKeyword": {
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
    },
  },
}));

function SelectedKeywords() {
  const [titleData, setTitleData] = useState([]);
  const [checkedKeywords, setCheckedKeywords] = useState([]);
  const [showCombinedTable, setShowCombinedTable] = useState(false);
  const [showGPTTable, setShowGPTTable] = useState(false);
  const [showGeminiTable, setShowGeminiTable] = useState(false);
  //  const [showCombinedTable, setShowCombinedTable] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [GET_TITLES] = useMutation(GET_TITLE);
  // const [GET_GEMINI_TITLES] = useMutation(GET_GEMINI_TITLE);
  const location = useLocation();
  const {
    state: { projectId, selectedKeywords },
  } = location || {};
  const [keywords, setKeywords] = useState(selectedKeywords);
  const theme = useTheme();
  const customizer = useSelector(state => state.customizer);

  const [selectedTitleInfo, setSelectedTitleInfo] = useState({ title: "", focusKeyword: "" });

  const handleTitleSelect = (event, dataSource) => {
    const selectedTitle = event.target.value;
    let focusKeyword;
    if (Array.isArray(titleData)) {
      focusKeyword = titleData.find(title => title.includes(selectedTitle)).split(" : ")[1];
    } else if (titleData[dataSource]) {
      focusKeyword = titleData[dataSource].find(title => title.includes(selectedTitle)).split(" : ")[1];
    }
    focusKeyword = focusKeyword || "";

    setSelectedTitleInfo({ title: selectedTitle, focusKeyword: focusKeyword });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      // setShowCombinedTable(false);
      const { data } = await GET_TITLES({
        variables: {
          keywords: checkedKeywords,
        },
      });
      setTitleData(data.getKeywordTitle);
      setLoading(false);
      setShowGPTTable(true);
      setShowGeminiTable(false);
      setShowCombinedTable(false);
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
    }
  };
  // const handleSubmitGemini = async () => {
  //   try {
  //     setLoading(true);
  //     // setShowCombinedTable(false);
  //     const { data } = await GET_GEMINI_TITLES({
  //       variables: {
  //         keywords: checkedKeywords,
  //       },
  //     });
  //     setTitleData(data?.getGeminiTitle);
  //     setLoading(false);
  //     setShowGPTTable(false);
  //     setShowGeminiTable(true);
  //     setShowCombinedTable(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error:", error);
  //   }
  // };

  // const handleGenerateTitlesForBoth = async () => {
  //   try {
  //     setLoading(true);

  //     let gptTitleData = null;
  //     let geminiTitleData = null;

  //     // Try to fetch GPT titles
  //     try {
  //       const { data: titleData } = await GET_TITLES({
  //         variables: {
  //           keywords: checkedKeywords,
  //         },
  //       });
  //       gptTitleData = titleData.getKeywordTitle;
  //     } catch (error) {
  //       console.error("Error fetching GPT titles:", error);
  //       gptTitleData = []; // Handle error by setting it to empty array or another fallback
  //     }

  //     // Try to fetch Gemini titles
  //     try {
  //       const { data: geminiTitleDataResponse } = await GET_GEMINI_TITLES({
  //         variables: {
  //           keywords: checkedKeywords,
  //         },
  //       });
  //       geminiTitleData = geminiTitleDataResponse.getGeminiTitle;
  //     } catch (error) {
  //       console.error("Error fetching Gemini titles:", error);
  //       geminiTitleData = []; // Handle error by setting it to empty array or another fallback
  //     }

  //     // Combine data
  //     const combinedData = {
  //       gptTitleData,
  //       geminiTitleData,
  //     };

  //     setTitleData(combinedData);
  //     setShowGPTTable(false);
  //     setShowGeminiTable(false);
  //     setShowCombinedTable(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleRemoveKeyword = index => {
    const updatedKeywords = [...keywords];
    updatedKeywords.splice(index, 1);
    setKeywords(updatedKeywords);
  };

  const handleCheckboxChange = keyword => {
    if (checkedKeywords.includes(keyword)) {
      setCheckedKeywords(prevCheckedKeywords => prevCheckedKeywords.filter(kw => kw !== keyword));
    } else {
      setCheckedKeywords(prevCheckedKeywords => [...prevCheckedKeywords, keyword]);
    }
  };

  const handleGenerateClick = generatorType => {
    const pathname = `/urlKeywords/selected-keywords/generate-blog?menu=headerKeywords`;
    const state = {
      selectedTitleInfo: selectedTitleInfo,
      keywords: keywords,
      generator: generatorType,
      projectId: projectId,
    };
    navigate(pathname, { state: state });
  };

  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12} md={12}>
              <BoxWrapper>
                <Box className="KeywordsWrapper">
                  <Card sx={{ padding: { xs: "15px 15px 50px 15px", sm: "30px 30px 24px 30px" }, border: `1px solid ${theme.palette.divider}`, marginBottom: "15px" }}>
                    <Typography component="h2" className="TableMainHeading">
                      Select Focus Keywords For Title Generation
                    </Typography>
                    <Table className="KewordTable KewordTableTop">
                      <TableHead>
                        <TableRow>
                          <TableCell>Keywords</TableCell>
                          <TableCell>Monthly Searches</TableCell>
                          <TableCell>Competition</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {keywords?.length > 0 ? (
                          keywords?.map((keyword, index) => (
                            <TableRow key={index}>
                              <TableCell>{keyword.keyword}</TableCell>
                              <TableCell>{keyword.monthly_searches}</TableCell>
                              <TableCell>{keyword.competition}</TableCell>
                              <TableCell>
                                <Checkbox checked={checkedKeywords.includes(keyword.keyword)} onChange={() => handleCheckboxChange(keyword.keyword)} disabled={loading} />
                                <Button
                                  onClick={e => {
                                    e.stopPropagation();
                                    handleRemoveKeyword(index);
                                  }}
                                  className="deleteIconKeyword"
                                  disabled={loading}
                                >
                                  <CancelRoundedIcon />
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={4}>
                              <Typography variant="body2">No keywords selected</Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    <Box className="FooterBtnWrapper">
                      <Button className="submitBtnKeyword" onClick={handleSubmit} disabled={checkedKeywords.length === 0 || loading}>
                        Generate Title
                      </Button>
                    </Box>
                  </Card>
                  {loading ? (
                    <MainLoader message="Loading" />
                  ) : (
                    <>
                      {showGPTTable && (
                        <GPTDataTable
                          titleData={titleData}
                          handleTitleSelect={handleTitleSelect}
                          selectedTitleInfo={selectedTitleInfo}
                          showGPTTable={showGPTTable}
                          handleGenerateClick={handleGenerateClick}
                        />
                      )}
                    </>
                  )}
                </Box>
              </BoxWrapper>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default SelectedKeywords;
